import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import {
  FormControlLabel,
  ListItem,
  MenuItem,
  Radio,
  RadioGroup,
  Select
} from '@material-ui/core';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import FileUpload from '../../components/molecules/FileUpload';
import GochiChildFoodListAddConfirm from './GochiChildFoodListAddConfirm';
import { resizeImage, uploadFile, sendLogin } from '../../auth/Auth';
import {
  getGochiChildFoodLists,
  addGochiChildFoodList,
  addGochiChildFoodListImage,
  getChildFoodGroups,
  getChildFoodShops
} from '../../actions/GochiChildFoodLists';
import { getAccounts } from '../../actions/Accounts';
import ValidationText from '../../components/atoms/ValidationText';
import { languages, languageType } from '../../constants/Language';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px'
    },
    display: 'flex',
    flexDirection: 'column'
  },
  alignEnd: {
    alignSelf: 'end'
  },
  editTable: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  button: {
    margin: '5px auto'
  },
  priceCalc: {
    margin: '0px 5px',
    color: '#aaa'
  },
  colLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingBottom: 5
    }
  },
  colRight: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    }
  },
  hideMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  width100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'block',
      padding: 0
    }
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      shops: state.shops.list,
      groups: state.groups.list,
      languages
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getChildFoodShops,
          getChildFoodGroups,
          getAccounts,
          getGochiChildFoodLists,
          addGochiChildFoodList,
          addGochiChildFoodListImage
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAddProgress', 'updateOpenAddProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isAddSuccess', 'updateIsAddSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('shopName', 'setShopName', ''),
  withState('shopNameError', 'setShopNameError', ''),
  withState('groupName', 'setGroupName', ''),
  withState('groupNameError', 'setGroupNameError', ''),
  withState('childFoodName', 'setChildFoodName', ''),
  withState('childFoodNameError', 'setChildFoodNameError', ''),
  withState('childFoodDescription', 'setChildFoodDescription', ''),
  withState('childFoodImage', 'setChildFoodImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('translateType', 'setTranslateType', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      let dataFirst = {};
      const origilData = {
        shopId: null,
        groupId: null,
        childFoodName: null,
        childFoodDescription: null
      };
      const arr = [];
      languages.forEach(item => {
        if (item.value === languageType.ORIGIN) {
          dataFirst = origilData;
        } else {
          const other = {
            translateType: 0,
            language: item.value
          };
          arr.push(other);
        }
      });
      dataFirst.otherLanguages = arr;
      this.props.setMultiLangData(dataFirst);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    searchKey,
    openAddConfirm,
    updateOpenAdd,
    updateOpenAddConfirm,
    openAddProgress,
    updateOpenAddProgress,
    loading,
    updateLoading,
    isAddSuccess,
    updateIsAddSuccess,
    resultMessage,
    setResultMessage,
    account,
    shopId,
    setShopId,
    groupId,
    setGroupId,
    shopName,
    setShopName,
    shops,
    groupName,
    setGroupName,
    groups,
    childFoodName,
    setChildFoodName,
    childFoodDescription,
    setChildFoodDescription,
    childFoodImage,
    setChildFoodImage,
    previewImage,
    setPreviewImage,
    shopNameError,
    setShopNameError,
    groupNameError,
    setGroupNameError,
    childFoodNameError,
    setChildFoodNameError,
    isLanguage,
    setIsLanguage,
    multiLangData,
    setMultiLangData,
    translateType,
    setTranslateType
  }) => {
    const isCreateChildFoodShop =
      typeof account !== 'undefined' &&
      account.role === 'SHOP' &&
      (account.belongToChildGroups !== 'undefined' &&
        account.belongToChildGroups.length > 0);

    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';

    const errors = {
      shopNameError,
      groupNameError,
      childFoodNameError
    };
    const validShopName = () => {
      const value = shopId;
      if (value === 0) {
        setShopNameError('必須項目です。');
        return 1;
      }
      setShopNameError('');
      setShopId(value);
      return 0;
    };
    const validGroupName = () => {
      const value = groupId;
      if (value === 0) {
        setGroupNameError('必須項目です。');
        return 1;
      }
      setGroupNameError('');
      setGroupId(value);
      return 0;
    };
    const validChildFoodName = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = childFoodName;
      if (value.trim() === '') {
        setChildFoodNameError('必須項目です。');
        return 1;
      }
      setChildFoodNameError('');
      setChildFoodName(value);
      return 0;
    };

    const valid = () => {
      const errorCount =
        validShopName() + validChildFoodName() + validGroupName();
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const setShopNameData = id => {
      shops.forEach(item => {
        if (id === item.shopId) {
          setShopName(item.shopName);
        }
      });
    };
    const setGroupNameData = id => {
      groups.forEach(item => {
        if (id === item.groupId) {
          setGroupName(item.groupName);
        }
      });
    };

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        shopId,
        groupId,
        childFoodName,
        childFoodDescription
      };
      const otherParam = {
        translateType,
        language: lang,
        params: {
          childFoodName,
          childFoodDescription
        }
      };
      // origin
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other languages
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      const str = JSON.stringify(data);
      return JSON.parse(str);
    };

    const cancelAction = () => {
      updateOpenAdd(false);
      setShopId(0);
      setGroupId(-1);
    };
    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        setShopNameData(shopId);
        setGroupNameData(groupId);
        setMultiLangData(getCurrentData());
        updateOpenAddConfirm(true);
      }
    };
    const backAction = () => updateOpenAddConfirm(false);
    const registerAction = async () => {
      updateLoading(true);
      updateOpenAddProgress(true);
      const addedChildFoodList = await actions
        .addGochiChildFoodList(multiLangData)
        .then(data => checkSession(data));
      if (childFoodImage !== null) {
        let imageData = childFoodImage;
        if (imageData.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
          const { resizeImageFile } = await resizeImage(imageData);
          imageData = resizeImageFile;
        }
        const imagePath = await uploadFile(
          'child_food',
          addedChildFoodList.payload.childFoodId,
          imageData,
          'public'
        );
        actions
          .addGochiChildFoodListImage(addedChildFoodList.payload.childFoodId, {
            images: [
              {
                image: imagePath
              }
            ]
          })
          .then(data => checkSession(data));
      }
      if (addedChildFoodList.type === 'ADD_GOCHI_CHILD_FOOD_SUCCESS') {
        updateIsAddSuccess(true);
        actions
          .getGochiChildFoodLists(searchKey)
          .then(data => checkSession(data));
        setResultMessage('登録が完了しました。');
        updateLoading(false);
      } else {
        updateIsAddSuccess(false);
        setResultMessage('登録に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isAddSuccess) {
        updateOpenAdd(false);
        updateOpenAddConfirm(false);
        updateOpenAddProgress(false);
      } else {
        updateOpenAddProgress(false);
      }
    };

    const getGroupOptions = () => {
      const groupOptions = [];
      const tmpObj = { label: '', value: '0' };
      if (isSecretariat) {
        if (!shopId || shopId === 0) {
          groups
            .filter(item => item.groupType.toUpperCase() === 'OTHERS')
            .forEach(group => {
              groupOptions.push({
                label: group.groupName,
                value: String(group.groupId)
              });
            });
        } else {
          groups
            .filter(
              item =>
                item.groupType.toUpperCase() === 'OTHERS' &&
                item.shopIds &&
                item.shopIds.includes(shopId)
            )
            .forEach(group => {
              groupOptions.push({
                label: group.groupName,
                value: String(group.groupId)
              });
            });
        }
      }
      if (isCreateChildFoodShop) {
        groups
          .filter(item => account.belongToChildGroups.includes(item.groupId))
          .forEach(group => {
            groupOptions.push({
              label: group.groupName,
              value: String(group.groupId)
            });
          });
      }
      return { ...groupOptions, tmpObj };
    };

    const getShopOptions = () => {
      const shopOptions = [];
      shops.forEach(shop => {
        shopOptions.push({
          label: shop.shopName,
          value: String(shop.shopId)
        });
      });
      return shopOptions;
    };

    const selectShopOption = async v => {
      setGroupId(Number(0));
      setShopId(Number(v));
      await console.log('sonph, groupId ==', groupId);
    };

    // setting language
    const setLanguage = v => {
      const lang = isLanguage;
      const data = getCurrentData();
      if (
        (v !== languageType.ORIGIN && lang === languageType.ORIGIN) ||
        (v !== languageType.ORIGIN && lang !== languageType.ORIGIN)
      ) {
        // origin to other or other to other lang
        for (let k = 0; k < multiLangData.otherLanguages.length; k += 1) {
          if (multiLangData.otherLanguages[k].language === v) {
            setChildFoodName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.childFoodName
                ? multiLangData.otherLanguages[k].params.childFoodName
                : ''
            );
            setChildFoodDescription(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.childFoodDescription
                ? multiLangData.otherLanguages[k].params.childFoodDescription
                : ''
            );
            setTranslateType(
              multiLangData.otherLanguages[k].translateType
                ? multiLangData.otherLanguages[k].translateType
                : 0
            );
          }
        }
      } else if (v === languageType.ORIGIN) {
        // other to origin
        setChildFoodName(multiLangData.childFoodName);
        setChildFoodDescription(multiLangData.childFoodDescription);
      }
      setIsLanguage(v);
      setMultiLangData(data);
    };

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">メニュー登録</Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Select
            className={`${classes.textField} ${classes.alignEnd}`}
            value={isLanguage}
            onChange={e => {
              if (isLanguage === e.target.value) {
                return;
              }
              if (
                valid() ||
                (isLanguage !== languageType.ORIGIN && translateType === 0)
              ) {
                setLanguage(e.target.value);
              } else {
                alert('登録情報を正しく入力してください。');
              }
            }}
          >
            {languages.map(lang => (
              <MenuItem key={lang.value} value={lang.value}>
                {lang.label}
              </MenuItem>
            ))}
          </Select>
          {isLanguage !== languageType.ORIGIN && (
            <ListItem className={classes.itemForm}>
              <Typography component="div" className={classes.formInput}>
                <RadioGroup
                  value={translateType}
                  onChange={e => {
                    setTranslateType(parseInt(e.target.value, 10));
                  }}
                >
                  <FormControlLabel
                    value={0}
                    control={<Radio color="primary" />}
                    label="GG翻訳を選択"
                  />
                  <FormControlLabel
                    value={1}
                    control={<Radio color="primary" />}
                    label="自分で文章入力"
                  />
                </RadioGroup>
              </Typography>
            </ListItem>
          )}
          <Table className={classes.editTable}>
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <ReactSelectMaterialUi
                    required
                    label="店舗名*"
                    className={classes.textField}
                    defaultValue={String(shopId)}
                    options={getShopOptions()}
                    margin="normal"
                    onChange={v => {
                      selectShopOption(v);
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validShopName}
                  />
                  <ValidationText message={errors.shopNameError} />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
            )}
            {shopId > 0 && isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <ReactSelectMaterialUi
                    required
                    label="グループ名*"
                    className={classes.textField}
                    defaultValue={String(groupId)}
                    value={String(groupId)}
                    options={getGroupOptions()}
                    margin="normal"
                    onChange={z => {
                      setGroupId(Number(z));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validGroupName}
                  />
                  <ValidationText message={errors.groupNameError} />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
            )}
            {(!shopId || shopId <= 0) && isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <ReactSelectMaterialUi
                    disabled
                    required
                    label="グループ名*"
                    className={classes.textField}
                    defaultValue={String(groupId)}
                    // value={String(groupId)}
                    options={getGroupOptions()}
                    margin="normal"
                    onChange={z => {
                      setGroupId(Number(z));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validGroupName}
                  />
                  <ValidationText message={errors.groupNameError} />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
            )}

            <TableRow>
              <TableCell className={classes.colLeft}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <TextField
                  required
                  label="メニュー名"
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setChildFoodName(e.target.value);
                  }}
                  value={childFoodName}
                  inputProps={{
                    maxLength: isLanguage === languageType.ORIGIN ? 250 : 1000
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                  onBlur={validChildFoodName}
                />
                <ValidationText message={errors.childFoodNameError} />
              </TableCell>
              <TableCell className={classes.width100} />
            </TableRow>
            <TableRow>
              <TableCell className={classes.colLeft}>
                <AnyButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <TextField
                  label="説明"
                  multiline
                  rows="4"
                  className={classes.textFieldLong}
                  margin="normal"
                  onChange={e => {
                    setChildFoodDescription(e.target.value);
                  }}
                  value={childFoodDescription}
                  inputProps={{
                    maxLength: isLanguage === languageType.ORIGIN ? 1000 : 2500
                  }}
                  disabled={
                    isLanguage !== languageType.ORIGIN && translateType === 0
                  }
                />
              </TableCell>
              <TableCell className={classes.width100} />
            </TableRow>
            {isLanguage === languageType.ORIGIN && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <AnyButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <FileUpload
                    label="image"
                    setFile={setChildFoodImage}
                    previewImage={previewImage}
                    setPreviewImage={setPreviewImage}
                  />
                </TableCell>
                <TableCell className={classes.tableCellBorderNone} />
              </TableRow>
            )}
          </Table>
        </Paper>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openAddConfirm}>
          <GochiChildFoodListAddConfirm
            backAction={backAction}
            registerAction={registerAction}
            addConfirm={multiLangData}
            groupName={groupName}
            shopName={shopName}
            previewImage={previewImage}
            currentLanguage={isLanguage}
            openAddProgress={openAddProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
